import { useEffect } from 'react';
import { useStore } from '../data/store';
import Navigation from '../components/public/Navigation';
import Hero from '../components/public/Hero';
import About from '../components/public/About';
import Lineup from '../components/public/Lineup';
import Countdown from '../components/public/Countdown';
import Info from '../components/public/Info';
import Gallery from '../components/public/Gallery';
import BandApplicationTeaser from '../components/public/BandApplicationTeaser';
import Newsletter from '../components/public/Newsletter';
import Sponsors from '../components/public/Sponsors';
import Footer from '../components/public/Footer';
import CookieBanner from '../components/public/CookieBanner';
import Maintenance from '../components/public/Maintenance';

export default function PublicSite() {
  const fetchPublicData = useStore((s) => s.fetchPublicData);
  const settings = useStore((s) => s.settings);
  const loading = useStore((s) => s.loading);

  useEffect(() => {
    fetchPublicData();
  }, [fetchPublicData]);

  if (loading) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="text-text-muted font-body">Laden...</div>
      </div>
    );
  }

  if (settings?.maintenanceMode) return <Maintenance />;

  return (
    <>
      <Navigation />
      <main id="main-content">
        <Hero />
        <About />
        <Lineup />
        <Countdown />
        <Info />
        <Gallery />
        <BandApplicationTeaser />
        <Newsletter />
        <Sponsors />
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}
